module.exports = __webpack_public_path__ + "static/4-ef709c65f4e73e57a8927e78c8e65000.png";